import './i18n';
import 'react-dates/initialize';

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { isProductionMode } from '@utils/get-environment/get-environment';

import { App } from './app';

import 'react-dates/lib/css/_datepicker.css';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

if (isProductionMode) {
  root.render(<App />);
} else {
  import('@axe-core/react').then((axe) => {
    axe.default(React, ReactDOM, 1000);
    root.render(<App />);
  });
}
